import { ESopr1UserTypes } from '../../types/analytics/sopr1';

export function createBrand(builderId: number, userType: ESopr1UserTypes) {
  return `${builderId}/${userType}`;
}
